import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'


const LoadContainer = Loadable({ loader: () => import('layers/sensorManager/containers/LoadContainer/LoadContainer'), loading })
const HomePage = Loadable({ loader: () => import('layers/sensorManager/pages/HomePage/HomePage'), loading })
const AccessPage = Loadable({ loader: () => import('layers/sensorManager/pages/AccessPage/AccessPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route path={links.root} component={HomePage} />
    <Route path={links.config} component={AccessPage} />
    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
